<template>
  <el-dialog
    title="文件列表"
    width="500px"
    @closed="onclosed"
    class="file-dialog"
    :visible.sync="ishow"
    :modal="false"
  >
    <div class="file-main">
      <el-card class="file-item" v-for="d in files" :key="d.id">
        <el-row>
          <el-col :span="20"
            ><div class="file-title">{{ d.name }}</div></el-col
          >
          <el-col :span="4"
            ><div class="file-size">{{ $tools.fileSize(d.size) }}</div></el-col
          >
        </el-row>

        <div class="file-info">
          {{ d.creatorName }} 上传于 {{ $tools.timestampToTime(d.createTime) }}
          <el-link class="file-link" @click="down(d.id)">下载</el-link>
          
          <el-link  v-if="isImg(d.name)" class="file-link" @click="vimg(d.id)">预览
            <el-image :id="d.id" :z-index="9999" :preview-src-list="preview" src="img/touxiang.08803b0d.png"></el-image>
          </el-link>

          <el-link class="file-link" @click="del(d.id)"  v-if="canEdit">删除</el-link>
        </div>
      </el-card>
    </div>
    <div slot="footer" class="dialog-footer" v-if="canEdit">
      <sn-file-upload :relateId="relateId" :relateType="relateType" :files="files" :showList=false></sn-file-upload>
    </div>
  </el-dialog>
</template>

<script>
import SnFileUpload from './SnFileUpload.vue';
export default {
  components: { SnFileUpload },
  props: {
    canEdit: { type: Boolean, default: false },
    show: { type: Boolean, default: false },
    relateId: { type: Number, default: null },
    relateType: { type: String, default: null },
  },
  data() {
    return {
      ishow: false,
      files: [],
      rltId: null,
      rltType: null,
      preview: ["img/touxiang.08803b0d.png"],
    };
  },
  methods: {
    onclosed() {
      this.$emit("update:show", false);
    },
    list() {
      let _this = this;
      _this.$http.post(
        [
          "file/list",
          { relateId: _this.relateId, relateType: _this.relateType },
        ],
        [
          function (data) {
            _this.files = data;
            _this.ishow = true;
          },
        ], ".file-main"
      );
    },
    down(id) {
      window.open("/api/file/download/byId?id=" + id, '_blank');
    },
    del(id) {
      let _this = this;

      _this.$tConfirm.show("是否删除文件?", function () {
        _this.$http.post(
          ["file/delete", { id: id }],
          [
            function () {
              _this.list();
            },
          ],
          ".file-dialog"
        );
      });
    },
    isImg(name) {
      let types = [".png", ".jpg", '.gif'];
      let flag = false;

      types.forEach(function(a) {
        if (name.indexOf(a) != -1){
            flag = true;
        }
      });

      return flag;
    },
    vimg(id) {
      this.preview = ["/api/file/download/byId?id=" + id];
      document.getElementById(id).click();
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.list();
      } else {
        this.ishow = val;
      }
    },
  },
};
</script>

<style lang="scss">
.file-dialog {
  .file-main {
    height: 500px;
    overflow: auto;

    .file-item {
      margin-top: 10px;

      .file-title {
        font-size: 16px;
      }

      .file-size {
        color: #c0c4cc;
        font-size: 14px;
        float: right;
      }

      .file-info {
        color: #c0c4cc;
        font-size: 14px;

        .file-link {
          float: right;
          color: #66b1ff;
          margin-left: 5px;
        }
        .el-image {
          position: absolute;
        }
        .el-image__inner{
          visibility: hidden ;
          width: 0;
          height: 0;
        }
      }
    }
  }
}
</style>